export default {
    header: "Byli jste úspěšně odhlášeni",
    message: ""
}